import { render, staticRenderFns } from "./runtimeCategoriesConfig.vue?vue&type=template&id=1e77ab25"
import script from "./runtimeCategoriesConfig.vue?vue&type=script&lang=js"
export * from "./runtimeCategoriesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports